import { DataSource } from 'app/components/data/DataSource/DataSource'
import { LocalDataSource } from 'app/components/data/DataSource/Local'
import { RemotePagingDataSource, RemoteStaticDataSource } from 'app/components/data/DataSource/Remote'
import { isObjAndNotNull } from 'app/components/data/utils'
import { IDataSourceConfig } from './interfaces'

/**
 * DataSourceFactory
 * DataSourceFactory.create<T>(config) returns either a LocalDataSource or RemoteDataSource
 * depending on the config
 */
export class DataSourceFactory<T> {

  /**
   * Factory method
   * @param config
   */
  static create<U extends object>(config: IDataSourceConfig<U>): DataSource<U> {
    let dataSource: DataSource<U>
    const hasDataConfig = isObjAndNotNull(config.data)
    const hasTransportConfig = isObjAndNotNull(config.transport)

    if (hasTransportConfig) {
      const hasReadConfig = isObjAndNotNull(config.transport.read)
      const hasPagingConfig = isObjAndNotNull(config.transport.paging)
      const badTransportConfig = !hasReadConfig && !hasPagingConfig

      if (badTransportConfig) {
        throw new Error('transport config must have a "read" or "paging" attribute')
      }

      if (hasPagingConfig) {
        dataSource = new RemotePagingDataSource(config)
      } else {
        dataSource = new RemoteStaticDataSource(config)
      }
    } else if (hasDataConfig) {
      dataSource = new LocalDataSource<U>(config)
    } else {
      throw new Error('config must have a "transport" or "data" attribute')
    }

    return dataSource
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/DataSourceFactory.ts